<div class="summary-container" animate.enter="loaded-fade-enter" animate.leave="loaded-fade-leave">
  <div class="summary-content">
    <div class="reservation-details">
      <div class="detail-row">
        <div class="vehicle-section">
          <span class="detail-label">Vehículo:</span>
          <span class="detail-value">{{ vehicle()?.Name || vehicle()?.VehicleType }}</span>
          @if (vehicle()?.ImageFile?.FileUri) {
          <div class="vehicle-image">
            <img [src]="vehicle()?.ImageFile.FileUri" [alt]="vehicle()?.Name" />
          </div>
          }
        </div>

        @if (company()?.LogoFile?.FileUri) {
        <div class="company-logo">
          <img [src]="company()?.LogoFile.FileUri" [alt]="company()?.Company" />
        </div>
        }
      </div>

      <hr class="detail-separator" />

      <div class="detail-row">
        <span class="detail-label">Días de la reserva:</span>
        <span class="detail-value">{{ formatDateRange() }} <small class="fw-normal">antes de las 11:00 h.</small></span>
      </div>

      <hr class="detail-separator" />

      <div class="detail-row">
        <span class="detail-label">Preferencia hora:</span>
        <span class="detail-value">{{ formatTimePreference() }}</span>
      </div>

      <hr class="detail-separator" />

      <div class="detail-row">
        <span class="detail-label">Punto de entrega y recogida:</span>
        <div class="detail-value address-value">
          <div class="address-lines" [innerHTML]="deliveryAddressHtml()" data-ap-external></div>
        </div>
      </div>
    </div>
  </div>

  @if (showActions) {
  <div class="confirmation-section">
    <div class="confirmation-content">
      <div class="reservation-footer-actions">
        <button class="btn btn-outline-primary btn-lg" (click)="onBack()">Modificar</button>
        <button class="btn btn-primary btn-lg" (click)="onConfirm()">Confirmar</button>
      </div>
    </div>
  </div>
  }

</div>
